module.exports = __webpack_public_path__ + "static/media/icon-financement.a4d01775.svg";